import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ToastService } from '../util/service/toast/toast.service';
import { AuthService } from '../util/service/auth/auth.service';

@Component({
  selector: 'app-cosbots-form',
  templateUrl: './cosbots-form.component.html',
  styleUrls: ['./cosbots-form.component.scss'],
})
export class CosbotsFormComponent {
  cosbotsForm: FormGroup;

  constructor(private fb: FormBuilder, private http: HttpClient, private toastService: ToastService, private authService: AuthService) {
    this.cosbotsForm = this.fb.group({
      membershipNo: ['', Validators.required],
      membershipType: ['', Validators.required],
      posoMoney: [''],
      orangeMoney: [''],
      fiveMega: [''],
      myzaka: [''],
      eWallet: [''],
      title: ['', Validators.required],
      surname: ['', Validators.required],
      firstName: ['', Validators.required],
      pseudonym: [''],
      nationality: ['', Validators.required],
      dob: ['', Validators.required],
      passport: ['', Validators.required],
      groupName: [''],
      postalAddress: ['', Validators.required],
      physicalAddress: ['', Validators.required],
      locality: ['', Validators.required],
      country: ['', Validators.required],
      telephone: [''],
      mobile: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      employer: [''],
      occupation: [''],
      bankName: ['', Validators.required],
      branch: [''],
      accountNumber: ['', Validators.required],
      accountType: [''],
      paymentReference: [''],
      mobilePaymentType: [''],
    });
  }

  onSubmit() {
    const headers = new HttpHeaders({
      'X-Client-Id': 'COSBOTS-CLIENT',
      'X-Client-Secret': '4mfkPN7JuTteaQtzThvOBI5gm5J61MKgIBP5KiyinlI',
      // 'Content-Type': 'multipart/form-data'
    });

    // if (this.cosbotsForm.valid) {
    //   console.log('Form Submitted', this.cosbotsForm.value);
    //   // alert('Form Submitted Successfully');
    // }

    if (this.cosbotsForm.invalid) {
      this.cosbotsForm.markAllAsTouched(); // show validation messages
      return;
    }

    const formData = new FormData();

    // const payload = {
    //   "Member Type": this.cosbotsForm.value.membershipType,
    //   "Poso Money": this.cosbotsForm.value.posoMoney,
    //   "Orange Money": this.cosbotsForm.value.orangeMoney,
    //   "5Mega": this.cosbotsForm.value.fiveMega,
    //   "MyZaka": this.cosbotsForm.value.myzaka,
    //   "E-Wallet": this.cosbotsForm.value.eWallet,
    //   "Title": this.cosbotsForm.value.title,
    //   "Surname": this.cosbotsForm.value.surname,
    //   "First Name": this.cosbotsForm.value.firstName,
    //   "Stage Name": this.cosbotsForm.value.pseudonym,
    //   "Nationality": this.cosbotsForm.value.nationality,
    //   "Date of Birth": this.cosbotsForm.value.dob,
    //   "Passport": this.cosbotsForm.value.passport,
    //   "Group Name": this.cosbotsForm.value.groupName,
    //   "Postal Address": this.cosbotsForm.value.postalAddress,
    //   "Physical Address": this.cosbotsForm.value.physicalAddress,
    //   "Locality": this.cosbotsForm.value.city,
    //   "Country": this.cosbotsForm.value.country,
    //   "Telephone": this.cosbotsForm.value.telephone,
    //   "Mobile": this.cosbotsForm.value.mobile,
    //   "Email Address": this.cosbotsForm.value.email,
    //   "Employer": this.cosbotsForm.value.employer,
    //   "Occupation": this.cosbotsForm.value.occupation,
    //   "Bank Name": this.cosbotsForm.value.bankName,
    //   "Branch": this.cosbotsForm.value.branch,
    //   "Account Number": this.cosbotsForm.value.accountNumber,
    //   "Account Type": this.cosbotsForm.value.accountType,
    //   "Payment Reference": this.cosbotsForm.value.paymentReference,
    // };

    

    const payload = {
      // Membership
      "Membership No": this.cosbotsForm.value.membershipNo,  // added membershipType Value for Membership No = EMB-103
      "Member Type": this.cosbotsForm.value.membershipType,
      // Mobile Payment
      "Title": this.cosbotsForm.value.title,
      "Surname": this.cosbotsForm.value.surname,
      "First Name": this.cosbotsForm.value.firstName,
      "Stage Name": this.cosbotsForm.value.pseudonym,
      "Nationality": this.cosbotsForm.value.nationality,
      "Date of Birth": this.cosbotsForm.value.dob,
      "Passport": this.cosbotsForm.value.passport,
      "Group Name": this.cosbotsForm.value.groupName,
    
      // Identity
      "Postal Address": this.cosbotsForm.value.postalAddress,
      "Physical Address": this.cosbotsForm.value.physicalAddress,
      "Locality": this.cosbotsForm.value.locality,
      "Country": this.cosbotsForm.value.country,
      "Telephone": this.cosbotsForm.value.telephone,
      "Mobile": this.cosbotsForm.value.mobile,
      "Email Address": this.cosbotsForm.value.email,
      "Employer": this.cosbotsForm.value.employer,
      "Occupation": this.cosbotsForm.value.occupation,
    
      // Contact
      "Bank Name": this.cosbotsForm.value.bankName,
      "Branch": this.cosbotsForm.value.branch,
      "Account Number": this.cosbotsForm.value.accountNumber,
      "Account Type": this.cosbotsForm.value.accountType,
      "Source of funds": this.cosbotsForm.value.paymentReference, // added paymentReference Value for Source of funds
      "Mobile Payment Type": this.cosbotsForm.value.mobilePaymentType // added new value based on payload
    };
    
   

    formData.append('payload', JSON.stringify(payload));

    // this.http.post('https://hooks.virtual-datarooms.uk/lukab/160d5e75-e8da-4cf0-9c4b-435f1129ecb2', formData, { headers })
    this.http
      .post('https://hooks.virtual-datarooms.uk/lukab/160d5e75-e8da-4cf0-9c4b-435f1129ecb2', formData, {
        headers,
        observe: 'response'
      })
      .subscribe({
        next: (res) => {
          const statusCode = res.status;
          // alert('Form submitted successfully!');
          // alert(`Form submitted!\nStatus: ${statusCode}`);
          this.toastService.showToast(
            `Form submitted Successfully!`,
            'success',
            statusCode
          );
          console.log('Full Response:', res);
          console.log('Payload:', payload);
        },
        error: (err) => {
          const statusCode = err.status;
          const errorMsg = err.error?.message || err.message || 'Unknown error';
          // alert('Form submission failed!');
          // alert(`Submission failed!\nStatus: ${statusCode}\nMessage: This request is invalid. Please check your Membership ID and other details.`);
          this.toastService.showToast(
            `Submission failed! Please check your Membership ID and other details.`,
            'error',
            statusCode
          );
          console.error(err);
          console.error(errorMsg);
        },
      });
  }

  logout(): void {
    this.authService.logout();
  }
}
